import { BlinqLogo } from '@components/BlinqAssets';
import { useEffect, useState } from 'react';

import { LandingButton } from './LandingButton';
import * as styles from './LandingNav.css';

interface LandingNavProps {
  claimHref: string;
  ctaLabel: string;
  onClaimClick?: () => void;
}

/** Reads whether the page has scrolled past the top, for the sticky nav's hairline. */
function useScrolled(threshold = 8): boolean {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const update = () => setScrolled(window.scrollY > threshold);
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, [threshold]);

  return scrolled;
}

export const LandingNav = ({ claimHref, ctaLabel, onClaimClick }: LandingNavProps) => {
  const scrolled = useScrolled();

  return (
    <header className={styles.nav} data-scrolled={scrolled}>
      <div className={styles.inner}>
        <a href="https://blinq.me" className={styles.logoLink} aria-label="Blinq">
          <BlinqLogo className={styles.logo} />
        </a>
        <div className={styles.cta}>
          <LandingButton href={claimHref} size="compact" onClick={onClaimClick}>
            {ctaLabel}
          </LandingButton>
        </div>
      </div>
    </header>
  );
};
